(function(){
  var header=document.querySelector('[data-header]');
  function onScroll(){ if(!header) return; header.classList.toggle('is-scrolled', window.scrollY>8); }
  onScroll(); window.addEventListener('scroll', onScroll, {passive:true});
  var drawer=document.querySelector('[data-mobile-drawer]');
  document.querySelectorAll('[data-mobile-open]').forEach(function(b){b.addEventListener('click',function(){drawer&&drawer.classList.add('is-open');document.body.classList.add('drawer-open');});});
  document.querySelectorAll('[data-mobile-close]').forEach(function(b){b.addEventListener('click',function(){drawer&&drawer.classList.remove('is-open');document.body.classList.remove('drawer-open');});});
  var search=document.querySelector('[data-mobile-search]');
  document.querySelectorAll('[data-search-toggle]').forEach(function(b){b.addEventListener('click',function(){search&&search.classList.toggle('is-open');});});
  var shop=document.querySelector('[data-mobile-shop]');
  document.querySelectorAll('[data-mobile-shop-toggle]').forEach(function(b){b.addEventListener('click',function(){shop&&shop.classList.toggle('is-open');b.classList.toggle('is-open');});});
  var end=Date.now()+47*3600*1000;
  function tick(){var diff=Math.max(0,end-Date.now()),h=Math.floor(diff/36e5),m=Math.floor(diff%36e5/6e4),s=Math.floor(diff%6e4/1e3);document.querySelectorAll('[data-hours]').forEach(function(e){e.textContent=String(h).padStart(2,'0')});document.querySelectorAll('[data-minutes]').forEach(function(e){e.textContent=String(m).padStart(2,'0')});document.querySelectorAll('[data-seconds]').forEach(function(e){e.textContent=String(s).padStart(2,'0')});}
  tick(); setInterval(tick,1000);
  document.querySelectorAll('[data-qty-minus]').forEach(function(b){ if(b.closest('.product-luxe-wrap')) return; b.addEventListener('click',function(){var i=b.parentElement.querySelector('input'); if(i) i.value=Math.max(1,parseInt(i.value||'1',10)-1);});});
  document.querySelectorAll('[data-qty-plus]').forEach(function(b){ if(b.closest('.product-luxe-wrap')) return; b.addEventListener('click',function(){var i=b.parentElement.querySelector('input'); if(i) i.value=parseInt(i.value||'1',10)+1;});});
  document.querySelectorAll('[data-thumb]').forEach(function(btn){ if(btn.closest('.product-luxe-wrap')) return; btn.addEventListener('click',function(){var main=document.querySelector('[data-main-product-image]'); var src=btn.getAttribute('data-src'); if(main&&src) main.src=src;});});
})();


(function(){
  function updateCartCount(count){
    document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = count; });
  }
  function showMessage(form, text, isError){
    var msg = form.querySelector('[data-cart-message]');
    if(!msg){
      msg = document.createElement('div');
      msg.setAttribute('data-cart-message','');
      msg.setAttribute('role','status');
      form.appendChild(msg);
    }
    msg.textContent = text;
    msg.classList.toggle('is-error', !!isError);
  }
  function setButton(button, text, disabled){
    if(!button) return;
    var label = button.querySelector('span');
    if(label) label.textContent = text; else button.textContent = text;
    if(typeof disabled === 'boolean') button.disabled = disabled;
  }
  document.addEventListener('submit', function(event){
    var form = event.target;
    if(!form || !form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    var original = button ? (button.querySelector('span') ? button.querySelector('span').textContent : button.textContent) : 'Add to Cart';
    setButton(button, 'Adding...', true);
    showMessage(form, '', false);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function(response){
      if(!response.ok){
        return response.json().then(function(data){ throw new Error(data.description || data.message || 'Unable to add item.'); });
      }
      return response.json();
    }).then(function(){
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    }).then(function(response){ return response.json(); })
    .then(function(cart){
      updateCartCount(cart.item_count || 0);
      setButton(button, 'Added!', false);
      showMessage(form, 'Added to cart successfully.', false);
      setTimeout(function(){ setButton(button, original, false); }, 1400);
    }).catch(function(error){
      setButton(button, original, false);
      showMessage(form, error.message || 'Unable to add item. Please try again.', true);
    });
  }, true);
})();

// FIX ADD TO CART AJAX
document.addEventListener('submit', async function(e){
  const form = e.target;
  if(!form.classList.contains('product-form')) return;

  e.preventDefault();

  const data = new FormData(form);

  try{
    const res = await fetch('/cart/add.js', {
      method:'POST',
      body:data
    });

    if(res.ok){
      window.location.href = '/cart';
    } else {
      console.log('Cart error');
    }
  }catch(err){
    console.log(err);
  }
});
